
import { eRewardType, eTaskType } from '@/interface/prize';
import { Component, Prop, Vue } from 'vue-property-decorator';
import PrizeItem from './_PrizeItem.vue';
@Component({
  components: { PrizeItem },
})
export default class extends Vue {
  @Prop() model!: any;
  @Prop() taskType!: object[];
  @Prop() isDisabled!: boolean;
  noTask: eTaskType = eTaskType.NO;
  pangolinTask: eTaskType = eTaskType.PANGOLIN;
  totalTimes: eTaskType = eTaskType.TOTALTIMES;
  dayTotalMoney: eTaskType = eTaskType.DAYTOTALMONEY;
  secretKey: string = '';
}
